import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import CompanyIntro from './components/CompanyIntro';
import CoreSolutions from './components/CoreSolutions';
import WhyChooseUs from './components/WhyChooseUs';
import ImpactSection from './components/ImpactSection';
import CTASection from './components/CTASection';

const Homepage = () => {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';

    // Cleanup on unmount
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>VASTECH | Elevating the Standards of Comfort | HVAC & Elevator Solutions</title>
        <meta
          name="description"
          content="VASTECH is a leading engineering solutions provider specializing in advanced HVAC systems, smart elevators, and intelligent building technologies in the UAE."
        />
        <meta
          name="keywords"
          content="VASTECH, HVAC systems, smart elevators, building technologies, engineering solutions UAE, precision engineering, sustainable infrastructure"
        />
        <meta name="author" content="VASTECH" />
        <meta property="og:title" content="VASTECH | Elevating the Standards of Comfort" />
        <meta
          property="og:description"
          content="Innovative HVAC systems, smart elevators, and advanced building technologies designed to improve comfort, efficiency, and performance."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://vastech.ae/" />
        <link rel="canonical" href="https://vastech.ae/" />
      </Helmet>
      
      <div className="min-h-screen bg-white text-slate-900 font-sans selection:bg-accent/30">
        <Header />

        <main className="relative">
          {/* Partitioned Hero Section */}
          <HeroSection />

          {/* Company Introduction */}
          <CompanyIntro />

          {/* Our Core Solutions */}
          <CoreSolutions />

          {/* Why Choose VASTECH */}
          <WhyChooseUs />

          {/* Our Impact / Metrics */}
          <ImpactSection />

          {/* Final Call to Action */}
          <CTASection />
        </main>

        {/* Minimalistic Footer */}
        <Footer />
      </div>
    </>
  );
};

export default Homepage;